import React from 'react';
import { Select } from '@avila-tek/ui/src';
import { Frequency, Plan } from '../../../models';

interface SubscriptionInputsProps {
  plans: Plan[];
  planSelected: Partial<Plan>;
  setPlanSelected: React.Dispatch<React.SetStateAction<Partial<Plan>>>;
}

function SubscriptionInputs({
  plans,
  planSelected,
  setPlanSelected,
}: SubscriptionInputsProps) {
  const [frequencies, setFrequencies] = React.useState<Frequency[]>([]);

  const onPlanChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const plan = plans.find((_plan) => _plan._id === e.target.value);
    setPlanSelected({ ...plan, frequencies: [] });
    setFrequencies(plan.frequencies);
  };

  const onFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const frequency = frequencies.find(
      (_frequency) => _frequency._id === e.target.value
    );
    setPlanSelected({
      ...planSelected,
      frequencies: [frequency],
    });
  };

  return (
    <div className="w-full flex md:flex-row flex-col gap-5 my-5">
      <div className="w-full">
        <Select
          value={planSelected?._id ?? ''}
          label="Tipo de suscripción"
          placeholder="Tipo de suscripción"
          onChange={onPlanChange}
          required
        >
          <option disabled value="">
            Seleccione un plan
          </option>

          {plans?.map((plan) => (
            <option value={plan._id}>{plan.title}</option>
          ))}
        </Select>
      </div>
      <div className="w-full">
        <Select
          name=""
          value={
            planSelected?.frequencies?.length > 0
              ? planSelected?.frequencies[0]?._id
              : ''
          }
          label="Duración de la suscripción"
          placeholder="Selecciones la duración "
          onChange={onFrequencyChange}
          required
        >
          <option disabled value="">
            Seleccione la frecuencia
          </option>

          {frequencies?.map((frequency) => (
            <option value={frequency?._id}>{frequency?.time}</option>
          ))}
        </Select>
      </div>
    </div>
  );
}

export default SubscriptionInputs;
